/* eslint-disable */
// @ts-nocheck
import React from "react";

export default function FallbackUI({ error, resetErrorBoundary }): JSX.Element {
    const mailtoHref = `mailto:electronictickets@baileyhelicopters.com?subject=Ticket App crashed @ ${new Date().toJSON()}`;
    return (
        <div style={{ width: 600, margin: "0 auto", color: "#FF0000", textAlign: "center" }}>
            <h2>The app has encountered something unexpected!</h2>
            <h3>Please make a note of what you were doing when this happened and email support at</h3>
            <h3>
                <a href={mailtoHref}>electronictickets@baileyhelicopters.com </a>
            </h3>
            <h3>with the details. Some diagnostic information has been sent to the support team automatically.</h3>
            <br />
            <h2>First try closing the app and re-opening it.</h2>
            <h3>If the error persists after restarting the app, use the button below to re-install.</h3>
            <br />
            <h1>Re-installing will delete any data that has not been synced to the server.</h1>
            <br />
            <button style={{ fontSize: 16 }} onClick={resetErrorBoundary}>
                RE-INSTALL
            </button>
        </div>
    );
}
